import get from 'lodash/get';
import reducerNamespace from '../constants/reducerNamespace';

const ERROR_MESSAGE = 'errorMessageModal';

const getErrorMessageNamespace = (state) => get(state, `${reducerNamespace}.${ERROR_MESSAGE}`, null);

/**
 * @param  {Object} state
 * @return {bool}
 */
export const getIsOpen = (state) => getErrorMessageNamespace(state).isOpen;
